import { useEffect, useState } from "react";
import "../../scss/Footer.scss";
import { Link, useNavigate } from "react-router-dom";
import apiFetch from "@wordpress/api-fetch";
import { basicFetchRequest } from "../functions/functions.jsx";
import { useGlobalState } from "../GlobalContext.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faPhoneVolume,
} from "@fortawesome/pro-regular-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
export default function Footer(props) {
  const {
    editProduct,
    setEditedProduct,
    fieldsData,
    setFieldsData,
    setSelectedConfigurator,
    setActiveField,
    setStatusQuotationFolder,
    setCompleteQuotation,
    quotationFolder,
    configuratorHubspotUrl,
  } = useGlobalState();
  const { data, selectedConfigurator, setHeaderData } = props;
  const navigate = useNavigate();

  const handleClickToHome = () => {
    setEditedProduct(""); // Remove editing in product when user clicks home button
    setFieldsData({}); // Remove old fieldsData
    setSelectedConfigurator(""); // Remove selected configurator
    setActiveField(0);
    setStatusQuotationFolder(false);
    setCompleteQuotation(false);
    navigate(`/${configuratorHubspotUrl}`);
  };

  const getIcon = (iconName) => {
    switch (iconName) {
      case "faPhone":
        return faPhone;
      case "faEnvelope":
        return faEnvelope;
      case "faPhoneVolume":
        return faPhoneVolume;
      case "faWhatsapp":
        return faWhatsapp;
      default:
        return null; // Return null or a default icon if no match is found
    }
  };

  const getFooterLink = (iconName) => {
    switch (iconName) {
      case "faPhone":
        return "tel:0342404130"; // Replace with actual phone number
      case "faEnvelope":
        return "mailto:info@degalux.nl"; // Replace with actual email address
      case "faPhoneVolume":
        return "tel:0342404130"; // Replace with actual phone number
      case "faWhatsapp":
        return "https://wa.me/0342404130"; // Replace with actual WhatsApp number
      default:
        return null; // Return null or a default link if no match is found
    }
  };

  return (
    <>
      <footer className="footer">
        {props?.footer?.footer_field && (
          <div className="footer-background">
            <div className="container">
              <ul>
                {props?.footer?.footer_field?.map((field, index) => {
                  return (
                    <li key={index}>
                      <a href={getFooterLink(field?.icon)}>
                        <span className="icon">
                          <FontAwesomeIcon icon={getIcon(field?.icon)} />
                        </span>
                        <span className="content">
                          <h4>{field?.title}</h4>
                          <p>{field?.description}</p>
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>

              <div className="footer-image">
                <figure>
                  <img src={props?.footer?.footer_image?.url} alt="" />
                </figure>
              </div>
            </div>
          </div>
        )}

        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Degalux</p>
        </div>
      </footer>
    </>
  );
}
